import { render, staticRenderFns } from "./NewLoan.vue?vue&type=template&id=34cf3154&scoped=true"
import script from "./NewLoan.vue?vue&type=script&lang=js"
export * from "./NewLoan.vue?vue&type=script&lang=js"
import style0 from "./NewLoan.vue?vue&type=style&index=0&id=34cf3154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cf3154",
  null
  
)

export default component.exports